import React from 'react';

import { primaryTheme } from '@repo/ui/components/Buttons';

import LinkButton from 'components/LinkButton/LinkButton';
import { FlexRow } from 'styles/layouts';

const Button = ({ slice }) => {
  return (
    <FlexRow justifyContent="center" marginBottom="24px">
      <LinkButton
        height="40px"
        href={slice.primary.link.url}
        label={slice.primary.label}
        theme={primaryTheme}
        width="auto"
      />
    </FlexRow>
  );
};

export default Button;
